export const STORAGE_TOKEN = 'token';
export const STORAGE_USER = 'user';
export const STORAGE_DEALER = 'dealer';
export const STORAGE_THEME = 'themeSet';

export const STORAGE_DATAFILTER = 'dataFilter';
export const STORAGE_EDITORDATA = 'editorData';
export const STORAGE_CUSTOMSTICKER = 'customSticker';
export const STORAGE_EXPORTDATA = 'exportData';
export const STORAGE_MAVISDATA = 'mavisData';
export const STORAGE_LASTACTIVEINDEX = 'lastActiveIndex';
export const STORAGE_LASTINACTIVEINDEX = 'lastInActiveIndex';
export const STORAGE_DIRECTLOGIN = 'directLogin';
export const STORAGE_BUCKET_RANGE = 'bucketRange';
export const STORAGE_EDITTRACKER_ISPENDING = 'isPending';
export const STORAGE_EDITTRACKER_ISQUEUESELECTEDFILTER = 'isQueueSelectedFilter';
export const STORAGE_EDITTRACKER_ENABLE_WEB_PUSH = 'enable-webpush-notification';
export const STORAGE_USER_VIEW = 'view';
export const STORAGE_TOGGLE_SALES_DEMO_MODE = 'sales-demo-mode-toggle';
